/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { type FC, type JSX } from 'react';

import CheckIcon from '../../Checkbox/Icon';
import type { Option } from '../../../index';
import { LiElement, LiElementAddLabel, LiElementLabel, UlElement } from './styled';

type ListProps = {
  options: Option[];
  columns?: number;
  limit?: number;
  value: any;
  name: string;
  isOverlay?: boolean;
  currentIndex?: number;
  handleItemClick: (item: Option) => void;
};

const List: FC<ListProps> = (props): JSX.Element => {
  const { options, columns, limit, value, name, isOverlay, currentIndex, handleItemClick } = props;
  const labelId = `lb_label_${name}`;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLLIElement>, item: Option) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      handleItemClick(item);
    }
  };

  return (
    <UlElement columns={columns} isOverlay={isOverlay}>
      {options.slice(0, limit).map((x, i) => {
        const isSelected = isOverlay ? i === currentIndex : value && value.indexOf(x.value) !== -1;
        const checkIcon = isOverlay ? null : <CheckIcon {...{ labelId, value: isSelected }} />;

        return (
          <LiElement
            key={`exp_elem_${name}_${x.value}`}
            role="option"
            isSelected={isSelected}
            tabIndex={0}
            columns={columns}
            isOverlay={isOverlay}
            {...{
              ...(x.disabled ? {} : { onClick: () => handleItemClick(x) }),
              ...(x.disabled ? {} : { onKeyDown: (e: React.KeyboardEvent<HTMLLIElement>) => handleKeyDown(e, x) }),
              ...(x.disabled ? { isDisabled: true } : {}),
              ...(isOverlay ? { id: `exp_elem_${name}_${x.value}` } : {}),
            }}
          >
            {columns && checkIcon}
            <LiElementLabel style={isOverlay ? { width: 'calc(100% - 8px)' } : {}}>{x.label}</LiElementLabel>
            <LiElementAddLabel>{x.addLabel}</LiElementAddLabel>
            {!columns && checkIcon}
          </LiElement>
        );
      })}
    </UlElement>
  );
};

export default List;
